import React from 'react';
import { IMLSNumbers } from '@bb/users';
import styled from 'styled-components';
import {
  Col,
  Row,
  Icon,
  Dropdown,
  Text,
  UniversalSearch,
  theme,
} from 'components';
import { CHAT_SESSION_STORAGE_KEYS } from 'utils';
import {
  AuthContext,
  AuthContextUser,
  LayoutContext,
  ListingLabelContext,
} from 'contexts';
import { StyledSearchWrapper } from './StyledComponents';

export const unassume = (
  auth: AuthContextUser,
  { redirect }: { redirect?: string } = { redirect: '' },
) => {
  CHAT_SESSION_STORAGE_KEYS.forEach(key => sessionStorage.removeItem(key));
  if (auth.assumerIdMlsStaff) {
    window.location.replace('/answering/unassume_user');
  } else {
    window.location.replace(
      `/answering/unassume${redirect ? `?redirect=${redirect}` : ''}`,
    ); // Outside of Router
  }
};

const AnsweringAssumeNavbar: React.FC = () => {
  const { updateTopElementHeight: updateHeight } =
    React.useContext(LayoutContext);
  const { auth } = React.useContext(AuthContext);
  const { getBoardName } = React.useContext(ListingLabelContext);
  const [searchVisible, setSearchVisible] = React.useState(false);
  const searchBarContainer = React.useRef();

  const handleUnassumeClick = () => unassume(auth);

  const getMlsNumbersText = (mlsNumbers: AuthContextUser['mls_numbers']) =>
    mlsNumbers
      .map(
        mlsData => `${getBoardName(mlsData.board, false)}: ${mlsData.number}`,
      )
      .join(', ');

  React.useEffect(() => {
    updateHeight('answeringAssume', 25);
  }, [updateHeight]);

  const assumedBrokerageName = auth.org.mls_name;

  return (
    <>
      <Row align="middle" className="assume-row">
        <Col>
          <button className="exit-button" onClick={handleUnassumeClick}>
            <Text strong>EXIT</Text>
          </button>
        </Col>
        <Col>
          <div ref={searchBarContainer}>
            <Dropdown
              open={searchVisible}
              trigger={['click']}
              onOpenChange={(visible: boolean) => setSearchVisible(visible)}
              getPopupContainer={() => searchBarContainer.current}
              // @ts-ignore
              destroyPopupOnHide
              dropdownRender={() => (
                <StyledSearchWrapper>
                  <UniversalSearch orgType="answering" showTable />
                </StyledSearchWrapper>
              )}
            >
              <button className="change-button">
                <Icon
                  type="search"
                  width={14}
                  color="white"
                  className="search-icon"
                />
                <Text strong>CHANGE</Text>
              </button>
            </Dropdown>
          </div>
        </Col>
        <Col flex="auto">
          <AssumedInfoTextContainer>
            {auth.assumerIdMlsStaff ? (
              <div>
                You have assumed{' '}
                <strong>
                  {auth.firstName} {auth.lastName},{' '}
                  {getMlsNumbersText(auth.mls_numbers)}
                </strong>{' '}
                of <strong>{auth.org.name}</strong>
              </div>
            ) : (
              <div>
                You are <strong>{assumedBrokerageName}</strong>
              </div>
            )}
          </AssumedInfoTextContainer>
        </Col>
      </Row>
    </>
  );
};

export default AnsweringAssumeNavbar;

const AssumedInfoTextContainer = styled.div`
  width: 100%;
  color: ${theme.white};
  text-align: center;
`;
